import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http'
import { CompressionAlgorithm } from '@opentelemetry/otlp-exporter-base'
import { BatchLogRecordProcessor, LoggerProvider } from '@opentelemetry/sdk-logs'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { logs } from '@opentelemetry/api-logs'

import { OptionalService } from './src/utils/constants'
import { isServiceEnabled } from './src/utils/optionalServices'

if (isServiceEnabled(OptionalService.DistributedTracing)) {

    const logExporter = new OTLPLogExporter({
        url: '/log-proxy',
        compression: CompressionAlgorithm.GZIP
    })
    const logRecordProcessor = new BatchLogRecordProcessor(logExporter, {
        maxExportBatchSize: 10,
    })
    const loggerProvider = new LoggerProvider({
        resource: resourceFromAttributes({
            [ATTR_SERVICE_NAME]: 'nighttune-frontend'
        }),
        processors: [logRecordProcessor]
    })

    logs.setGlobalLoggerProvider(loggerProvider)
} else {
    console.info('Distributed tracing service disabled, only logging to browser console.')
}